var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "checkbox-wrapp flex flex-col gap-6" },
    _vm._l(_vm.checkboxes, function (checkbox) {
      return _c(
        "input-checkbox",
        {
          key: checkbox.id,
          attrs: {
            value: checkbox.id,
            name: _vm.name,
            theme: _vm.theme,
            "text-in-label": true,
            checked: _vm.value.includes(checkbox.id),
          },
          on: { input: _vm.handleChange },
        },
        [_vm._v(_vm._s(checkbox.text))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }